import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconTriangleAlertProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconTriangleAlert: React.FC<IconTriangleAlertProps> = ({
    color = 'warning',
    size = 'md',
    className = '',
    title = 'Warning',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 9v4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 17h.01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconTriangleAlert;
